import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconCheck,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import type { RankingFilterAge } from 'shared/src/api';

export const useAgeSelectBottomSheet = createUseBottomSheetModal<
  { nextValue: RankingFilterAge },
  { selected: string | null; list: RankingFilterAge[] }
>(({ confirm, param }) => {
  return (
    <BottomSheetContainer>
      <VerticalSpacing size={16} />
      {param.list.map(item => {
        const selected = item.query_value['age_tags[]'] === param.selected;
        return (
          <Flex.Row
            alignItems={'center'}
            justifyContent={'space-between'}
            padding={{ horizontal: 16, vertical: 16 }}
            onPress={() => confirm({ nextValue: item })}
          >
            <Typography
              type={selected ? 'subtitle1' : 'body1'}
              color={selected ? 'content_pink_primary' : undefined}
            >
              {item.name}
            </Typography>
            {selected ? (
              <IconCheck size={20} fill={Colors.content_pink_primary} />
            ) : (
              <></>
            )}
          </Flex.Row>
        );
      })}
    </BottomSheetContainer>
  );
});
